export default __webpack_public_path__ + "static/media/groups.1e57cc7e.svg";